export default "__VITE_ASSET__72cebe57__"